module.exports = __webpack_public_path__ + "img/bannerWrap.b4c7e161.png";